export interface FavoriteItem {
  key: string;
  type: "work" | "news";
  id: string;
  title: string;
  cover: string;
  meta: string;
  savedAt: number;
}

export const FAVORITES_STORAGE_KEY = "wmm-favorites-v1";
export const MAX_FAVORITES = 50;
export const FAVORITES_EVENT = "wmm-favorites-change";

export function readFavorites(): FavoriteItem[] {
  try {
    const raw = window.localStorage.getItem(FAVORITES_STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry): entry is FavoriteItem => {
      if (!entry || typeof entry !== "object") return false;
      const value = entry as Partial<FavoriteItem>;
      return typeof value.key === "string" && typeof value.title === "string";
    });
  } catch {
    return [];
  }
}

export function writeFavorites(items: FavoriteItem[]) {
  try {
    window.localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(items));
  } catch {
    // ignore storage quota errors
  }
  window.dispatchEvent(new Event(FAVORITES_EVENT));
}

export interface ToggleResult {
  added: boolean;
  full: boolean;
}

export function toggleFavoriteEntry(item: Omit<FavoriteItem, "savedAt">): ToggleResult {
  const current = readFavorites();
  const exists = current.some((entry) => entry.key === item.key);

  if (exists) {
    writeFavorites(current.filter((entry) => entry.key !== item.key));
    return { added: false, full: false };
  }

  if (current.length >= MAX_FAVORITES) {
    return { added: false, full: true };
  }

  writeFavorites([{ ...item, savedAt: Date.now() }, ...current]);
  return { added: true, full: false };
}